import type { OwnStayIngredient } from '@apps/main/modules/recipe/ingredients/ownStayIngredient';

import { SelectedHotelTypeQL } from '@libs/trip-planner-interfaces';
import type { HotelConstraintQL } from '@libs/trip-planner-interfaces';

import { isHotelIngredient } from '../../../recipe/ingredients';
import type { HotelIngredient } from '../../../recipe/ingredients';

export function adaptHotelIngredientToHotelConstraintQL(
  destination: HotelIngredient | OwnStayIngredient,
  maxNumberOfHotels = 1
): HotelConstraintQL {
  const constraint: HotelConstraintQL = {
    destination: destination.searchText,
    maxNumberOfHotels,
    selectedHotelTypes: [SelectedHotelTypeQL.Golf, SelectedHotelTypeQL.Ticket],
    boardBasis: [],
  };

  if (isHotelIngredient(destination)) {
    constraint.destination =
      destination.commonPolygonText ?? destination.searchText;
    constraint.polygonId = destination.polygonId;
  }

  return constraint;
}
